import { Chapter as ChapterType } from '@core/types';
import { useTranslation } from 'react-i18next';
import { ChapterContainer } from '../ChapterContainer';

export const ChaptersContainer = ({
    onChapterClick,
    chapters,
    activeChapter
}: {
    onChapterClick?: (chapter: ChapterType) => void;
    chapters: ChapterType[];
    activeChapter: ChapterType | null | undefined;
}) => {
    const { t } = useTranslation();
    return (
        <ul className="h-full min-h-13 list-none overflow-y-auto overscroll-contain px-1 py-2 select-none" data-testid="ChaptersList">
            {chapters.map((chapter: ChapterType) => {
                return <ChapterContainer key={`${chapter.chapterId}`} chapter={chapter} activeChapter={activeChapter} onChapterClick={onChapterClick} />;
            })}
        </ul>
    );
};
